import i18n from "features/shared/i18n";

export function DangerZone({ onDelete }: { onDelete: () => void }) {
  return (
    <div className="bg-[rgba(252,101,96,0.05)] border border-[rgba(252,101,96,0.2)] rounded-[16px] p-5">
      <div className="flex-row-el items-center gap-2 text-[21px] text-danger mb-4">
        <span className="material-symbols-outlined text-[30px]">warning</span>
        {i18n.t("MSG_PARENT_PAGE_DANGER_ZONE")}
      </div>
      <div className="flex-row-el items-center justify-between gap-4">
        <div className="flex-1">
          <div className="text-[22px] text-textcolor-black mb-1">
            {i18n.t("MSG_PARENT_PAGE_DELETE_CHILD")}
          </div>
          <div className="text-[19px] text-gray2-100">
            {i18n.t("MSG_PARENT_PAGE_DELETE_CHILD_WARNING")}
          </div>
        </div>
        <button
          className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-transparent border-2 border-danger rounded-[10px] text-[21px] text-danger hover:bg-danger hover:text-white transition-all"
          onClick={onDelete}
        >
          <span className="material-symbols-outlined text-[27px]">delete_forever</span>
          {i18n.t("MSG_PARENT_PAGE_DELETE_BTN")}
        </button>
      </div>
    </div>
  );
}
